export interface ShippingOption {
  carrier: string;
  type: "air" | "sea";
  estimate: string;
}

export interface RegionShipping {
  carriers: ShippingOption[];
  note?: string;
}

export const regionShipping: Record<string, RegionShipping> = {
  "Southeast Asia": {
    carriers: [
      { carrier: "DHL Express", type: "air", estimate: "2–4 days" },
      { carrier: "FedEx", type: "air", estimate: "3–5 days" },
      { carrier: "UPS", type: "air", estimate: "3–5 days" },
      { carrier: "Sea Freight (LCL/FCL)", type: "sea", estimate: "5–8 days" },
    ],
  },
  "East Asia": {
    carriers: [
      { carrier: "DHL Express", type: "air", estimate: "3–5 days" },
      { carrier: "FedEx", type: "air", estimate: "4–6 days" },
      { carrier: "UPS", type: "air", estimate: "4–6 days" },
      { carrier: "Sea Freight (LCL/FCL)", type: "sea", estimate: "7–10 days" },
    ],
  },
  "South Asia": {
    carriers: [
      { carrier: "DHL Express", type: "air", estimate: "3–5 days" },
      { carrier: "FedEx", type: "air", estimate: "4–6 days" },
      { carrier: "EMS", type: "air", estimate: "5–8 days" },
      { carrier: "Sea Freight (LCL/FCL)", type: "sea", estimate: "7–12 days" },
    ],
  },
  "Middle East": {
    carriers: [
      { carrier: "DHL Express", type: "air", estimate: "4–6 days" },
      { carrier: "FedEx", type: "air", estimate: "5–7 days" },
      { carrier: "UPS", type: "air", estimate: "5–7 days" },
      { carrier: "Sea Freight (LCL/FCL)", type: "sea", estimate: "14–18 days" },
    ],
  },
  Europe: {
    carriers: [
      { carrier: "DHL Express", type: "air", estimate: "3–5 days" },
      { carrier: "FedEx", type: "air", estimate: "4–6 days" },
      { carrier: "UPS", type: "air", estimate: "4–6 days" },
      { carrier: "Sea Freight (LCL/FCL)", type: "sea", estimate: "21–30 days" },
    ],
  },
  "North America": {
    carriers: [
      { carrier: "DHL Express", type: "air", estimate: "3–5 days" },
      { carrier: "FedEx", type: "air", estimate: "3–5 days" },
      { carrier: "UPS", type: "air", estimate: "4–6 days" },
      { carrier: "Sea Freight (LCL/FCL)", type: "sea", estimate: "21–28 days" },
    ],
  },
  "Central America & Caribbean": {
    carriers: [
      { carrier: "DHL Express", type: "air", estimate: "4–7 days" },
      { carrier: "FedEx", type: "air", estimate: "5–8 days" },
      { carrier: "Sea Freight (LCL/FCL)", type: "sea", estimate: "21–30 days" },
    ],
  },
  "South America": {
    carriers: [
      { carrier: "DHL Express", type: "air", estimate: "4–7 days" },
      { carrier: "FedEx", type: "air", estimate: "5–8 days" },
      { carrier: "UPS", type: "air", estimate: "5–8 days" },
      { carrier: "Sea Freight (LCL/FCL)", type: "sea", estimate: "25–35 days" },
    ],
  },
  Africa: {
    carriers: [
      { carrier: "DHL Express", type: "air", estimate: "3–6 days" },
      { carrier: "FedEx", type: "air", estimate: "4–7 days" },
      { carrier: "EMS", type: "air", estimate: "7–12 days" },
      { carrier: "Sea Freight (LCL/FCL)", type: "sea", estimate: "21–30 days" },
    ],
  },
  Oceania: {
    carriers: [
      { carrier: "DHL Express", type: "air", estimate: "3–5 days" },
      { carrier: "FedEx", type: "air", estimate: "4–6 days" },
      { carrier: "UPS", type: "air", estimate: "4–6 days" },
      { carrier: "Sea Freight (LCL/FCL)", type: "sea", estimate: "14–21 days" },
    ],
  },
};
